import { Box, styled } from '@material-ui/core';

const StyledAPIRequestHandler = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0),
}));
export { StyledAPIRequestHandler };
